import { createActions } from 'redux-actions';
import { HealthClaim } from '@models/HealthClaim';
import {
  GetHealthClaimParams,
  UpdateHealthClaimParams,
  UploadHealthClaimDocumentsParams,
  UpdateHealthClaimSettlementLetterNotesParams,
  ApproveHealthClaimParams
} from '@apis/HealthClaimApi';
import { BenefitLimit } from '@models/BenefitLimit';
import { GetAllBenefitLimitParams } from '@apis/BenefitLimitApi';
import {
  GetAllHealthClaimCostItemParams,
  CreateHealthClaimCostItemParams,
  UpdateHealthClaimCostItemParams,
  DeleteHealthClaimCostItemParams,
  ApproveAllHealthClaimCostItemParams
} from '@apis/HealthClaimCostItemApi';
import { HealthClaimCostItem } from '@models/HealthClaimCostItem';

export type State = {
  serverErrors: object;
  healthClaim: HealthClaim | null | undefined;
  isUpdatingHealthClaim: boolean;
  benefitLimits?: BenefitLimit[] | null;
  healthClaimCostItems?: HealthClaimCostItem[] | null;
};
export type HealthClaimFetchPayload = GetHealthClaimParams;
export type HealthClaimUpdatePayload = UpdateHealthClaimParams;
export type HealthClaimUploadDocumentsPayload = UploadHealthClaimDocumentsParams;
export type HealthClaimSettlementLetterNotesUpdatePayload = UpdateHealthClaimSettlementLetterNotesParams;
export type HealthClaimApprovePayload = ApproveHealthClaimParams;
export type BenefitLimitsFetchPayload = GetAllBenefitLimitParams;
export type HealthClaimCostItemsFetchPayload = GetAllHealthClaimCostItemParams;
export type HealthClaimCostItemCreatePayload = CreateHealthClaimCostItemParams;
export type HealthClaimCostItemUpdatePayload = UpdateHealthClaimCostItemParams;
export type HealthClaimCostItemDeletePayload = DeleteHealthClaimCostItemParams;
export type HealthClaimCostItemsApprovePayload = ApproveAllHealthClaimCostItemParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthClaimFetch,
  healthClaimUpdate,
  healthClaimUploadDocuments,
  healthClaimSettlementLetterNotesUpdate,
  healthClaimApprove,
  benefitLimitsFetch,
  healthClaimCostItemsFetch,
  healthClaimCostItemCreate,
  healthClaimCostItemCreateSuccess,
  healthClaimCostItemUpdate,
  healthClaimCostItemUpdateSuccess,
  healthClaimCostItemDelete,
  healthClaimCostItemDeleteSuccess,
  healthClaimCostItemsApprove,

  stateUpdate,
} = createActions(
  'HEALTH_CLAIM_FETCH',
  'HEALTH_CLAIM_UPDATE',
  'HEALTH_CLAIM_UPLOAD_DOCUMENTS',
  'HEALTH_CLAIM_SETTLEMENT_LETTER_NOTES_UPDATE',
  'HEALTH_CLAIM_APPROVE',
  'BENEFIT_LIMITS_FETCH',
  'HEALTH_CLAIM_COST_ITEMS_FETCH',
  'HEALTH_CLAIM_COST_ITEM_CREATE',
  'HEALTH_CLAIM_COST_ITEM_CREATE_SUCCESS',
  'HEALTH_CLAIM_COST_ITEM_UPDATE',
  'HEALTH_CLAIM_COST_ITEM_UPDATE_SUCCESS',
  'HEALTH_CLAIM_COST_ITEM_DELETE',
  'HEALTH_CLAIM_COST_ITEM_DELETE_SUCCESS',
  'HEALTH_CLAIM_COST_ITEMS_APPROVE',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_DETAILS_HEALTH_CLAIM_DETAILS',
  },
);
